import CategoriesContainer from './categories_container'

export default CategoriesContainer